import React from 'react';
import Icon from '../../mweb/Icon/Icon';
import './notification-card.scss';
import { Link } from 'react-router-dom';
import { getActionLink } from '../../../CPMapping';

const NotificationCard = ({ notification: n, onClick = () => {} }) => {
  let actionUrl = getActionLink(n);
  if (actionUrl === '#') actionUrl = null;
  if (n.orderNo) actionUrl = `/my/order/${n.orderNo}`;
  return (
    <div className={`notif-card ${n.isNotified ? 'read' : ''}`}>
      {actionUrl && (
        <Link to={actionUrl} className="notif-card--link" onClick={onClick}>
          <Icon src={n.icon} size={48} class="notif-card--icon flex-shrink-0" />
          <div className="notif-card--description">{n.description}</div>
        </Link>
      )}
      {!actionUrl && (
        <React.Fragment>
          <Icon src={n.icon} size={48} class="notif-card--icon flex-shrink-0" />
          <div className="notif-card--description">{n.description}</div>
        </React.Fragment>
      )}
    </div>
  );
};

export default NotificationCard;
